import React, { Component } from 'react'
import { reaction } from 'mobx'
import { observer, inject } from 'mobx-react'

import GoodsItem from './GoodsItem'

import config from '../config'
import api from '../services'
import utils from '../utils'
const { $ } = utils,{ pvIds } = config

@inject('cityInfo')
@inject('carInfo')
@observer
export default class HotFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: [],
      minPriceList: []
    }

    this.loadData = this.loadData.bind(this)
    this.getPrice = this.getPrice.bind(this)
    this.getMinPrice = this.getMinPrice.bind(this)

    reaction(
      () => {
        return {
          cityId: this.props.cityInfo.info.cityId,
          shouldLoad: this.props.carInfo.shouldLoadHot
        }
      },
      params => this.loadData(params.shouldLoad)
    )
  }

  async loadData(shouldLoad = false){
    if(!shouldLoad) {return}
    let { cityInfo } = this.props,cityId = cityInfo.info.cityId,
    redList = [],
    cxList = [],
    baseList = []
    
    await api.searchItem({
      pageSize: 5,
      cityId,
      dataSources: '12,17',
      businessFlagType: 0,
      businessFlag: '1'
    }).then(data => {
      if(data.returncode === 0 && data.result && data.result.count) {
        redList = data.result.list
      }
    })
    .catch(err => {
      $.toast({
        text: err.message,
        duration: 2000,
      })
    })

    await api.searchItem({
      pageSize: 5,
      cityId,
      dataSources: '12,17',
      businessFlagType: 0,
      businessFlag: '6,7,8,11,12,14,15,16,17'
    }).then(data => {
      if(data.returncode === 0 && data.result && data.result.count) {
        cxList = data.result.list
      }
    })
    .catch(err => {
      $.toast({
        text: err.message,
        duration: 2000,
      })
    })

    // 统计
    window.trackCustomEvent('auto_common_event',{
      'biz':'ec',
      'scene':0,
      'type':'show',
      'action':'mall_m_redpacket_promot_show',
      'ctime':new Date().getTime(),
      'area':0,
      'element':0,
      'pmark':0,
      'target':0,
      'ctype':0,
      'cid':0
    },{
      'ek1':0,
      'ek2':0
    })

    if([...redList,...cxList].length > 0) {
      this.setState({list:[...redList,...cxList]},this.getPrice)
      return
    }

    await api.searchItem({
      pageSize: 10,
      dataSources: '12,17',
      cityId
    }).then(data => {
      if(data.returncode === 0 && data.result && data.result.length) {
        baseList = data.result.list
      }
    })
    .catch(err => {
      $.toast({
        text: err.message,
        duration: 2000,
      })
    })

    this.setState({list:baseList},this.getPrice)
  }

  getPrice(){
    let { cityInfo } = this.props

    api.getPriceForList({
      city: cityInfo.info.cityId,
      itemIds: this.state.list.map(item => item.itemId).join(',')
    }).then(data => {
      if(data.returncode === 0){
        this.setState({
          minPriceList: data.result
        })
      }
    }).catch(()=>{})
  }

  getMinPrice(itemId) {
    let list = this.state.minPriceList
    return list.length ?
              list.filter(item => item.item.itemId === itemId)[0] ?
                list.filter(item => item.item.itemId === itemId)[0].minPrice
                  :
                  0
              :
              0
  }
  
  render(){
    return(
      <div className={this.state.list.length && this.props.carInfo.shouldLoadHot?'':'fn-hide'}>
        <div className='title'>
          <span>火热促销</span>
        </div>
        {
          this.state.list.map(
            item => <GoodsItem key={Math.random()}
                              goods={item}
                              pvId={pvIds.hot}
                              minPrice={this.getMinPrice(item.itemId)}
                              cityName={this.props.cityInfo.info.cityName}
                              city={this.props.cityInfo.info.cityId} />
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/HotFloor.js